import { useMemo } from 'react';
import { MobilitySortingField } from '../../../api/types';
import makeGetSortingRule from '../../../utilities/makeGetSortingRule';

export const getSortField = makeGetSortingRule((field): MobilitySortingField => {
    switch (field) {
        case 'module.company.displayName':
            return MobilitySortingField.Company;

        case 'title':
            return MobilitySortingField.Title;

        case 'referenceName':
            return MobilitySortingField.ReferenceName;

        case 'kind':
            return MobilitySortingField.Kind;

        case 'order':
            return MobilitySortingField.Order;

        case 'active':
            return MobilitySortingField.Active;

        default:
            throw new Error('Unknown Sorting Field!');
    }
});

const useSortOrder = sort => {
    const companySort = useMemo(
        () => (sort.field === MobilitySortingField.Company ? sort.orderValue : undefined),
        [sort]
    );

    const titleSort = useMemo(() => (sort.field === MobilitySortingField.Title ? sort.orderValue : undefined), [sort]);

    const referenceNameSort = useMemo(
        () => (sort.field === MobilitySortingField.ReferenceName ? sort.orderValue : undefined),
        [sort]
    );

    const kindSort = useMemo(() => (sort.field === MobilitySortingField.Kind ? sort.orderValue : undefined), [sort]);

    const orderSort = useMemo(() => (sort.field === MobilitySortingField.Order ? sort.orderValue : undefined), [sort]);

    const ActiveSort = useMemo(
        () => (sort.field === MobilitySortingField.Active ? sort.orderValue : undefined),
        [sort]
    );

    return {
        companySort,
        titleSort,
        referenceNameSort,
        kindSort,
        ActiveSort,
        orderSort,
    };
};

export default useSortOrder;
